export default __webpack_public_path__ + "static/bg-optimized-0aed91b541b24e9ed82a22432f7c3c8b.png";